// extracted by mini-css-extract-plugin
module.exports = {"root":"SettingList_root__3CuS2"};